import {
  AddedBadge,
  BrandLogo,
  BrandLogoItem,
} from '~/screens/PageBuilder/modals/BrandExperienceModal';

interface AvailableLogosProps {
  brandName: string;
  brandDomain: string;
  logos: BrandLogoItem[];
  onBrandSelect: (logo: string, name: string) => void;
}

export const AvailableLogos = ({
  brandName,
  brandDomain,
  logos,
  onBrandSelect,
}: AvailableLogosProps) => {
  return (
    <div
      className="absolute left-0 top-full z-[999999] mt-1 flex w-full flex-col gap-4 overflow-y-auto rounded-12 bg-neutral-0 p-4 shadow-xl"
      style={{
        maxHeight: '380px',
        minHeight: '200px',
      }}
    >
      <h3 className="text-root-size-body-xl font-400 text-neutral-700">
        Available <span className="font-500 text-neutral-800">{brandName}</span>{' '}
        logos
      </h3>

      <div className="flex gap-2">
        <div className="relative size-32">
          <BrandLogo
            src={`https://cdn.brandfetch.io/${brandDomain}/w/399/h/399/logo?c=1idan6GYmsZ2_dC4Lhg`}
            alt={`${brandName} logo variant`}
            variant="full"
            onClick={() => {
              const logoUrl = `https://cdn.brandfetch.io/${brandDomain}/w/399/h/399/logo?c=1idan6GYmsZ2_dC4Lhg`;
              onBrandSelect(logoUrl, brandName);
            }}
          />
          <AddedBadge
            isVisible={logos.some(
              (logo) =>
                logo.url ===
                `https://cdn.brandfetch.io/${brandDomain}/w/399/h/399/logo?c=1idan6GYmsZ2_dC4Lhg`,
            )}
          />
        </div>
        <div className="relative size-32">
          <BrandLogo
            src={`https://cdn.brandfetch.io/${brandDomain}/w/399/h/399?c=1idan6GYmsZ2_dC4Lhg`}
            alt={`${brandName} standard logo`}
            variant="standard"
            onClick={() => {
              const logoUrl = `https://cdn.brandfetch.io/${brandDomain}/w/399/h/399?c=1idan6GYmsZ2_dC4Lhg`;
              onBrandSelect(logoUrl, brandName);
            }}
          />
          <AddedBadge
            isVisible={logos.some(
              (logo) =>
                logo.url ===
                `https://cdn.brandfetch.io/${brandDomain}/w/399/h/399?c=1idan6GYmsZ2_dC4Lhg`,
            )}
          />
        </div>
      </div>
    </div>
  );
};
